"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _select = _interopRequireDefault(require("../select"));
var _Button = _interopRequireDefault(require("../button/Button"));
var _icon = _interopRequireDefault(require("../icon"));
var _tooltip = require("../tooltip");
var _misc = require("../misc");
var _SimpleRule = _interopRequireDefault(require("./SimpleRule.style"));
var _Operator = _interopRequireDefault(require("./Operator"));
var _Value = _interopRequireDefault(require("./Value"));
var _helpers = require("./helpers");
var _excluded = ["disabled", "type", "valuesUrl"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SimpleRule = /*#__PURE__*/function (_React$Component) {
  _inherits(SimpleRule, _React$Component);
  var _super = _createSuper(SimpleRule);
  function SimpleRule(params) {
    var _this;
    _classCallCheck(this, SimpleRule);
    _this = _super.call(this, params);
    _defineProperty(_assertThisInitialized(_this), "onRuleChange", function (ruleElementType, val, valueOperands) {
      var _this$state = _this.state,
        rule = _this$state.rule,
        ruleOperatorProps = _this$state.ruleOperatorProps,
        ruleValueProps = _this$state.ruleValueProps;
      var newRule = R.clone(rule);
      var newRuleValueProps = ruleValueProps;
      var newRuleOperatorProps = ruleOperatorProps;
      var elementValue = val;
      if (ruleElementType === 'operator') {
        if (rule.operator === elementValue) return;
        newRule.operator = elementValue;
        newRuleValueProps.disabled = false;
        newRule.values = [];
      } else if (ruleElementType === 'variable') {
        if (rule.variable === elementValue) return;
        newRuleValueProps.disabled = !rule.operator;
        newRuleValueProps.type = elementValue.type;
        newRuleValueProps.valuesUrl = elementValue.valuesUrl;
        _this.props.onLookupData(elementValue.valuesUrl);
        newRule.variable = elementValue;
        newRule.values = [];
        newRuleOperatorProps.disabled = false;
      } else if (ruleElementType === 'value') {
        if (rule.values === elementValue) return;
        newRule.values = R.isEmpty(R.prop(0, elementValue)) ? [] : elementValue;
      }
      _this.props.onRuleChange(newRule, _this.props.pathKeys, valueOperands);
      _this.setState({
        rule: newRule,
        ruleValueProps: newRuleValueProps,
        ruleOperatorProps: newRuleOperatorProps
      });
    });
    var originalRule = params.rule,
      variableOptions = params.variableOptions,
      onLookupData = params.onLookupData,
      operatorOptions = params.operatorOptions;
    var _rule = R.clone(originalRule);
    var _ruleValueProps = R.clone(_helpers.defaultRuleValueProps);
    variableOptions.forEach(function (option) {
      if (_rule.variable && _rule.variable === option.value) {
        _ruleValueProps.type = option.type;
        _ruleValueProps.valuesUrl = option.valuesUrl;
        if (option.valuesUrl) onLookupData(option.valuesUrl);
        _ruleValueProps.disabled = false;
      }
    });
    operatorOptions.forEach(function (option) {
      if (_rule.operator && _rule.operator === option.values) {
        _rule.operator = _objectSpread({}, option);
      }
    });
    _this.state = {
      rule: _objectSpread(_objectSpread({}, _helpers.defaultRule), _rule),
      ruleValueProps: _objectSpread(_objectSpread({}, _ruleValueProps), {
        disabled: !_rule.operator || !_rule.variable
      }),
      ruleOperatorProps: _objectSpread(_objectSpread({}, _helpers.defaultRuleOperatorsProps), {
        disabled: !_rule.variable
      })
    };
    return _this;
  }
  _createClass(SimpleRule, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        variableOptions = _this$props.variableOptions,
        operatorOptions = _this$props.operatorOptions,
        lookUpValues = _this$props.lookUpValues,
        isSelected = _this$props.isSelected,
        onAddNew = _this$props.onAddNew,
        onDuplicate = _this$props.onDuplicate,
        onDelete = _this$props.onDelete,
        pathKeys = _this$props.pathKeys,
        isDuplicateDisabled = _this$props.isDuplicateDisabled,
        maxDepth = _this$props.maxDepth,
        parentOperator = _this$props.parentOperator,
        labels = _this$props.labels,
        errors = _this$props.errors,
        hideMenu = _this$props.hideMenu,
        searchableAction = _this$props.searchableAction,
        rule = _this$props.rule,
        onClick = _this$props.onClick;
      var _this$state$ruleValue = this.state.ruleValueProps,
        disabled = _this$state$ruleValue.disabled,
        type = _this$state$ruleValue.type,
        valuesUrl = _this$state$ruleValue.valuesUrl,
        otherRuleValueProps = _objectWithoutProperties(_this$state$ruleValue, _excluded);
      var _this$state$rule = this.state.rule,
        variable = _this$state$rule.variable,
        operator = _this$state$rule.operator,
        values = _this$state$rule.values;
      var operatorValue = R.find(R.propEq('value', operator))(operatorOptions);
      var menuItems = [];
      var allowsMultipleSelect = R.prop('allowsMultipleSelect', operatorValue);
      if (!isDuplicateDisabled) {
        menuItems.push({
          name: labels.ELIGIBILITY_DUPLICATE_RULE || 'Duplicate',
          icon: 'ion-ios-copy',
          onClick: function onClick() {
            onDuplicate(pathKeys);
          }
        });
      }
      menuItems.push({
        name: labels.ELIGIBILITY_DELETE_RULE || 'Delete',
        icon: 'ion-trash-b',
        onClick: function onClick() {
          onDelete('rule', pathKeys);
        }
      });
      return /*#__PURE__*/_react["default"].createElement(_SimpleRule["default"], {
        key: id,
        id: id,
        isSelected: isSelected,
        hasErrors: !R.isEmpty(errors),
        onClick: onClick
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "rule-element value-element"
      }, /*#__PURE__*/_react["default"].createElement(_select["default"], {
        disabled: R.prop('disabled', this.props),
        valueRenderer: function valueRenderer(option) {
          return SimpleRule.renderSelectedValue(option, pathKeys.join('-'));
        },
        id: "".concat(id, "Variable"),
        searchable: true,
        value: variable,
        options: variableOptions,
        placeholder: labels.LEFT_OPERAND_PLACEHOLDER || 'Variable',
        onChange: function onChange(val) {
          _this2.onRuleChange('variable', val);
        },
        errors: R.prop('variable', errors)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "rule-element rule-operator"
      }, /*#__PURE__*/_react["default"].createElement(_Operator["default"], {
        id: "".concat(id, "Operator"),
        options: operatorOptions,
        onChange: function onChange(val) {
          _this2.onRuleChange('operator', val.value);
        },
        value: operatorValue,
        disabled: this.state.ruleOperatorProps.disabled || R.prop('disabled', this.props),
        labels: labels,
        errors: R.prop('operator', errors)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "rule-element rule-value"
      }, /*#__PURE__*/_react["default"].createElement(_Value["default"], _extends({
        variableOperands: rule.variableOperands,
        disabled: disabled || R.prop('disabled', this.props),
        id: "".concat(id, "Value"),
        onChange: function onChange(val, valueOperands) {
          _this2.onRuleChange('value', val, valueOperands);
        },
        type: type,
        lookUpValues: valuesUrl && lookUpValues ? lookUpValues[valuesUrl] : [],
        value: values,
        labels: labels,
        allowsMultipleSelect: allowsMultipleSelect,
        operatorValue: operatorValue,
        errors: R.prop('values', errors),
        searchableAction: searchableAction
      }, otherRuleValueProps))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "buttons-wrapper"
      }, isSelected && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "".concat(id, "AndButton"),
        className: "rule-buttons",
        action: function action() {
          onAddNew('AND', pathKeys);
        },
        medium: true,
        disabled: pathKeys && pathKeys.length >= maxDepth && parentOperator === 'OR' || R.prop('disabled', this.props)
      }, labels.ELIGIBILITY_AND_OPERATOR || 'AND'), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "".concat(id, "OrButton"),
        className: "rule-buttons",
        action: function action() {
          onAddNew('OR', pathKeys);
        },
        medium: true,
        disabled: pathKeys && pathKeys.length >= maxDepth && parentOperator === 'AND' || R.prop('disabled', this.props),
        type: "naked"
      }, labels.ELIGIBILITY_OR_OPERATOR || 'OR')), hideMenu && pathKeys[0] === 0 ? '' : /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
        disabled: R.prop('disabled', this.props),
        className: "rule-menu-list",
        menuItems: menuItems,
        position: "top-right",
        id: "".concat(id, "MenuList"),
        ignoreSingleItemLogic: true
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-android-more-vertical",
        id: "".concat(id, "MenuList")
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!R.equals(props.rule, state.rule)) {
        return {
          rule: _objectSpread({}, props.rule)
        };
      }
      return null;
    }
  }]);
  return SimpleRule;
}(_react["default"].Component);
_defineProperty(SimpleRule, "renderSelectedValue", function (option, id) {
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "".concat(id, "EligibilityTooltip")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ellipsis-overflow",
    "data-tip": option.label,
    "data-for": "".concat(id, "EligibilityTooltip"),
    "data-offset": "{ 'left':10}",
    "data-place": "top"
  }, option.label));
});
SimpleRule.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  hideMenu: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  /** A list with the position trail of the current rule */
  pathKeys: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  /** The parent operator */
  parentOperator: _propTypes["default"].string.isRequired,
  /** A list of system variables */
  variableOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** A list of operators */
  operatorOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** A list of posible options for a system variable (when a system variable has lookup data) */
  lookUpValues: _propTypes["default"].shape({}),
  /** A callback to call when selecting a system variable with lookup data */
  onLookupData: _propTypes["default"].func,
  /** Callback to perform when the rule elements change */
  onRuleChange: _propTypes["default"].func.isRequired,
  /** Callback to perform when duplicating a simple rule */
  onDuplicate: _propTypes["default"].func.isRequired,
  /** Callback to perform when deleting a simple rule */
  onDelete: _propTypes["default"].func.isRequired,
  /** Callback for when clicking the OR or AND buttons */
  onAddNew: _propTypes["default"].func.isRequired,
  /** Flag to indicate weather the current rule is selected */
  isSelected: _propTypes["default"].bool,
  /** Flag to indicate weather to disabled the duplicate item (eg. Duplicate first IF statement) */
  isDuplicateDisabled: _propTypes["default"].bool,
  /** Max rules depth value */
  maxDepth: _propTypes["default"].number,
  /** Object containing error messages for the elements in the rule */
  errors: _propTypes["default"].shape({}),
  /** CMS labels */
  labels: _propTypes["default"].shape({
    LEFT_OPERAND_PLACEHOLDER: _propTypes["default"].string,
    ELIGIBILITY_OR_OPERATOR: _propTypes["default"].string,
    ELIGIBILITY_AND_OPERATOR: _propTypes["default"].string,
    ELIGIBILITY_DELETE_RULE: _propTypes["default"].string,
    ELIGIBILITY_DUPLICATE_RULE: _propTypes["default"].string
  }),
  searchableAction: _propTypes["default"].func.isRequired,
  rule: _propTypes["default"].shape({
    variableOperands: _propTypes["default"].oneOfType([_propTypes["default"].array])
  }).isRequired
};
SimpleRule.defaultProps = {
  hideMenu: false,
  disabled: false,
  lookUpValues: null,
  errors: {},
  onLookupData: undefined,
  isSelected: false,
  isDuplicateDisabled: false,
  maxDepth: 3,
  labels: {}
};
SimpleRule.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onRuleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "ruleElementType",
      "type": null
    }, {
      "name": "val",
      "type": null
    }, {
      "name": "valueOperands",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderSelectedValue",
    "docblock": null,
    "modifiers": ["static"],
    "params": [{
      "name": "option",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "SimpleRule",
  "props": {
    "hideMenu": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "lookUpValues": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "A list of posible options for a system variable (when a system variable has lookup data)",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "Object containing error messages for the elements in the rule",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "onLookupData": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "A callback to call when selecting a system variable with lookup data",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "isSelected": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate weather the current rule is selected",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isDuplicateDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate weather to disabled the duplicate item (eg. Duplicate first IF statement)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "maxDepth": {
      "defaultValue": {
        "value": "3",
        "computed": false
      },
      "description": "Max rules depth value",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "labels": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "CMS labels",
      "type": {
        "name": "shape",
        "value": {
          "LEFT_OPERAND_PLACEHOLDER": {
            "name": "string",
            "required": false
          },
          "ELIGIBILITY_OR_OPERATOR": {
            "name": "string",
            "required": false
          },
          "ELIGIBILITY_AND_OPERATOR": {
            "name": "string",
            "required": false
          },
          "ELIGIBILITY_DELETE_RULE": {
            "name": "string",
            "required": false
          },
          "ELIGIBILITY_DUPLICATE_RULE": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "onClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "id": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "pathKeys": {
      "description": "A list with the position trail of the current rule",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "number"
        }
      },
      "required": true
    },
    "parentOperator": {
      "description": "The parent operator",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "variableOptions": {
      "description": "A list of system variables",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    },
    "operatorOptions": {
      "description": "A list of operators",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    },
    "onRuleChange": {
      "description": "Callback to perform when the rule elements change",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onDuplicate": {
      "description": "Callback to perform when duplicating a simple rule",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onDelete": {
      "description": "Callback to perform when deleting a simple rule",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onAddNew": {
      "description": "Callback for when clicking the OR or AND buttons",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "searchableAction": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "rule": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "variableOperands": {
            "name": "union",
            "value": [{
              "name": "array"
            }],
            "required": false
          }
        }
      },
      "required": true
    }
  }
};
var _default = SimpleRule;
exports["default"] = _default;